import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";
import {UsuariosRol} from "../../../infrastructure/layout/menu/widget-distribucion-roles/usuarios-rol";

@Injectable({
  providedIn: 'root'
})
export class ObtenerPorcentajeUsuariosPorRolService {
  private readonly permisosUrl: string;

  constructor(private httpClient: HttpClient) {
    this.permisosUrl = environment.apiUrl + '/administrador/permiso/usuarios-por-rol';
  }

  public __invoke(): Observable<UsuariosRol[]> {
    return this.httpClient.get<UsuariosRol[]>(this.permisosUrl);
  }
}
